import Axios from "../helper/appConfig";

export const getPolicy = async () => {
  const payload = {
    search: [
      {
        searchfield: "formid",
        searchvalue: "681474141870a2384958d1ca",
        criteria: "eq",
        datatype: "ObjectId",
      },
    ],
    select: [
      {
        fieldname: "property",
        value: 1,
      },
    ],
  };

  return Axios.post("api/formdatas/filter", payload);
};


export const getHotelPolicy = async () => {
  const payload = {
    search: [
      {
        searchfield: "formid",
        searchvalue: "681bc00d3fc19b47bf3ee142",
        criteria: "eq",
        datatype: "ObjectId",
      },
    ],
    select: [
      {
        fieldname: "property",
        value: 1,
      },
    ],
  };

  return Axios.post("api/formdatas/filter", payload);
};
